import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import ProductDetailPage from './components/ProductDetailPage';
import { CheckoutPage } from './components/CheckoutPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<App data-id="element-4" />} data-id="element-3" />
        <Route path="/pdp" element={<ProductDetailPage data-id="element-6" />} data-id="element-5" />
        <Route path="/checkout" element={<CheckoutPage data-id="element-8" />} data-id="element-7" />
      </Routes>
    </BrowserRouter>;
}